import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle,
} from '@angular/material/dialog';

@Component({
  selector: 'lassi-session-expired-dialog',
  imports: [MatDialogModule, MatDialogTitle, MatDialogContent, MatButtonModule],
  template: `
    <h2 mat-dialog-title class="mat-title-medium">
      <b>You've been logged out</b>
    </h2>
    <mat-dialog-content>
      <p class="mat-body-medium">Please sign in again</p>
      <button mat-button mat-dialog-close>Continue</button>
    </mat-dialog-content>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionExpiredDialogComponent {}
